import { Lightning, Clock } from "@phosphor-icons/react";

const TOOL_LABELS = {
  get_weather: "Weather",
  web_search: "Live search",
  get_crypto_price: "Crypto",
  get_sports_scores: "Sports",
};

function formatLocalTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  } catch {
    return "";
  }
}

/** Small chip rendered under the assistant bubble to surface that the
 *  reply contains LIVE data (not remembered context). Shows the tool
 *  name + the fetched_at timestamp in the user's local time so they
 *  can immediately tell how fresh the underlying data is. Used by
 *  V9.26 realtime tools: weather / web_search / crypto / sports. */
export default function LiveDataBadge({ entry }) {
  if (!entry?.result) return null;
  const ok = entry.result.ok;
  const label = TOOL_LABELS[entry.tool_name] || entry.tool_name || "Live";
  const time = formatLocalTime(entry.result.fetched_at);

  if (!ok) {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-500/10 border border-amber-500/25 text-amber-200 text-[11px]"
        data-testid={`live-badge-${entry.tool_name}-failed`}
        title={entry.result.error || ""}
      >
        <Clock size={11} weight="bold" />
        <span>{label} · unavailable</span>
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-cyan-500/10 border border-cyan-500/30 text-cyan-200 text-[11px]"
      data-testid={`live-badge-${entry.tool_name}`}
    >
      <Lightning size={11} weight="fill" className="text-cyan-300" />
      <span>Live · {time || "now"}</span>
      <span className="text-white/50">·</span>
      <span className="text-white/70">{label}</span>
    </span>
  );
}
